import React from 'react';
import { useDispatch } from 'react-redux';
import { sendVulnToServiceDeskContext } from 'store/Settings/serviceDesk/actions';
import first from 'lodash/first';
import { useIntl } from 'react-intl';
import {
  Wrapper, Title, Subtitle, Footer, Close, Save, Blue
} from './styled';

const ServiceDesk = ({ onClose, vulnsSelected, vulnId, isVulnDetailOpen, entity }) => {
  const dispatch = useDispatch();
  const intl = useIntl();

  const onSave = () => {
    dispatch(sendVulnToServiceDeskContext(vulnsSelected, vulnId, isVulnDetailOpen, entity));
    onClose();
  };

  const getText = () => ((vulnsSelected.length === 1) ? first(vulnsSelected).name : `${vulnsSelected.length} vulnerabilities`);

  return (
    <Wrapper>
      <Title>{ intl.formatMessage({ id: 'sendToTool.serviceDesk.title' }) }</Title>
      <Subtitle>
        { intl.formatMessage({ id: 'sendToTool.serviceDesk.message.youAreSending' }) }
        <Blue>{ getText() }</Blue>
        { intl.formatMessage({ id: 'sendToTool.serviceDesk.message.toServiceDesk' }) }
      </Subtitle>
      <Footer>
        <Close onClick={ onClose }>{ intl.formatMessage({ id: 'sendToTool.serviceDesk.form.close' }) }</Close>
        <Save onClick={ onSave }>{ intl.formatMessage({ id: 'sendToTool.serviceDesk.form.save' }) }</Save>
      </Footer>
    </Wrapper>
  );
};

export default ServiceDesk;
